import { AnalyticsEvent } from "@lonelyplanet/dotcom-analytics";
import MoreLink from "backpack-ui/dist/components/moreLink";
import { textAccent } from "backpack-ui/dist/utils/typography";
import * as React from "react";
import { createSuggestEditSlug } from "../../../../shared/utils/slug";
var SuggestEdit = function (_a) {
    var poi = _a.poi, location = _a.location;
    return (React.createElement(AnalyticsEvent, { render: function (track) { return (React.createElement(MoreLink, { target: "_blank", hideIcon: true, href: createSuggestEditSlug(poi, location), style: textAccent(), onClick: function (e) {
                track({
                    event: "suggest edit click",
                    "gtm.element": "suggestEdit",
                    "gtm.elementText": "Suggest an Edit",
                });
            } }, "Suggest an Edit")); } }));
};
export default SuggestEdit;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/suggestEdit/index.tsx
// module id = C+Uo
// module chunks = 2